/**
 * Copyright 2021 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Copyright 2021 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import Grid from "@material-ui/core/Grid";

import { Box } from "client/components/Box";
import { useSelectedTenantWithFallback } from "state/tenant/hooks/useTenant";
import GrafanaIframe from "client/components/Grafana/Iframe";

const TenantOverviewMetrics = () => {
  const tenant = useSelectedTenantWithFallback();

  return (
    <Box pt={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <GrafanaIframe
            initialHeight={1200}
            tenant="system"
            title="Tenant Overview: Metrics (Cortex)"
            path="/d/c82shqQZz/tenant-overview-cortex"
            params={{
              "var-tenant": tenant.name
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TenantOverviewMetrics;
